/* unplugin-vue-components disabled */import { render } from "./PdpAgreementScreenForm.vue?vue&type=template&id=022f8588&scoped=true&ts=true"
import script from "./PdpAgreementScreenForm.vue?vue&type=script&lang=ts"
export * from "./PdpAgreementScreenForm.vue?vue&type=script&lang=ts"

import "./PdpAgreementScreenForm.vue?vue&type=style&index=0&id=022f8588&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022f8588"]])

export default __exports__